/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'auth-profile-verify-ldap-modal-service';
const prefix = `${moduleName}.${componentName}`;

export const verifyProfileModalName = `${prefix}.verifyProfileModalName`;

export const ENGLISH = {
    [verifyProfileModalName]: 'Auth Profile',
};
